import { useTranslation } from "react-i18next";

// سقف السلفة المحسوب من سياسة الفرع + أقصى أشهر السداد.
export const AdvanceLimitBox = ({ rules }) => {
  const { t } = useTranslation();
  return (
    <div className="rounded-2xl p-4 shadow-neu-in sm:col-span-2" data-testid="advance-limit">
      <p className="text-xs text-muted-foreground">
        {t("advances.limitNote", {
          percent: rules.max_percent,
          salary: rules.basic_salary,
          currency: rules.currency,
        })}
      </p>
      <p className="mt-1 font-mono text-2xl font-black text-primary">
        {rules.max_amount} {rules.currency}
      </p>
      <p className="mt-1 text-xs text-muted-foreground" data-testid="advance-max-months">
        {t("advances.maxMonths", { months: rules.max_months })}
      </p>
    </div>
  );
};
